import {PlayerId, usePixiRenderContext} from '@glark-newco/game-library';
import {Container} from '@pixi/react';
import {useEffect, useState} from 'react';
import {ringRadius, RingSprite} from './RingSprite';
import {TRANSFER_RING_DURATION_MS} from './TransferRingAnimation';
import {usePlayerRings} from '../state/PlayerRingsSlice';


interface PlayerRingsProps {
    x: number,
    y: number,
    playerId: PlayerId,
    scale: number,
}

const offset = ringRadius;

function calcOverlap(idx: number): 'LEFT' | 'RIGHT' | 'NONE' {
    return idx === 0 ? 'NONE' : ((idx + 1) % 2) ? 'LEFT' : 'RIGHT';
}

// A collection of rings, which are hung from the players belt.
export function PlayerRings({x, y, playerId, scale}: PlayerRingsProps) {
    const ringIds = usePlayerRings(playerId);
    const [visibleRings, setVisibleRings] = useState(ringIds);
    const {triggerRender} = usePixiRenderContext();

    useEffect(() => {
        const added = ringIds.filter(ring => !visibleRings.includes(ring)).length > 0;
        const removed = visibleRings.filter(ring => !ringIds.includes(ring)).length > 0;
        if (removed) {
            // rings get removed immediately they are sent
            setVisibleRings(ringIds);
        }
        if (added) {
            // rings get received after the transfer animation is complete.
            setTimeout(() => {
                setVisibleRings(ringIds);
                triggerRender();
            }, TRANSFER_RING_DURATION_MS);
        }
    }, [ringIds]);

    return (
        <Container x={x} y={y} scale={scale}>
            {visibleRings.map((ringId, idx) =>
                <RingSprite key={ringId} x={((idx + 1) % 2) ? 0 : offset / 2.5} y={idx * offset} ringId={ringId} overlap={calcOverlap(idx)}/>,
            )}
        </Container>
    );
}
